import React from "react";
import {Card, Button, Image} from "react-bootstrap";
import {CgWebsite} from "react-icons/cg";


function ProjectCards(props) {
    return (
        <Card className="project-card-view">

            <Card.Body>
                <Image  src={props.imgPath} alt="card-img" width={props.width} height={props.height}
                        className='object-fit'/>
                <Card.Title>{props.title}</Card.Title>
                <Card.Text style={{textAlign: "justify"}}>
                    {props.description}
                </Card.Text>
                <Card.Text style={{textAlign: "left"}}>
                    Tech: {props.tech}
                </Card.Text>
                {"\n"}
                {"\n"}

                {/* If the component contains Demo link and if it's not a Blog then, it will render the below component  */}

                {!props.offline && props.demoLink &&  (
                    <Button
                        variant="primary"
                        href={props.demoLink}
                        target="_blank"
                        style={{marginLeft: "10px"}}
                    >
                        <CgWebsite/> &nbsp;
                        {"Visit"}
                    </Button>
                )}

                {
                    props.offline &&
                    <Card.Text style={{textAlign: "center"}} color='danger'>
                      <span className='text-danger'>Offline</span>
                    </Card.Text>
                }


            </Card.Body>
        </Card>
    );
}

export default ProjectCards;
